export const locale = {
  lang: 'pt',
  data: {
    'CIERRE': {
      'CARGANDO':'Carregando informações',
      'LABEL1': 'Pesquisa em andamento',
      'LABEL2': 'Ver pré-visualização',
      'LABEL3': 'Pesquisa completa',
      'LABEL4': 'Ver resultados',
      'LABEL5': 'Lembretes enviados com sucesso',
      'LABEL6': 'Você já enviou um email hoje',
      'LABEL7': 'Você só pode enviar lembretes a partir da data de lançamento',
      'LABEL8': 'Espere um momento.....',
      'LABEL9': 'Restantes dias',
      'BTN_CIERRE': 'Fechar agora',
      'ALERT':{
        'MESSAGE': 'Confirmar para completar a pesquisa mais cedo?',
        'BTN_CONFIRM': 'sim',
        'BTN_CANCEL': 'Não',
        'OK':'OK',
      },
      'ALERT_RE':{
        'MESSAGE': '¿Tem certeza que deseja enviar os lembretes?',
        'BTN_CONFIRM': 'sim',
        'BTN_CANCEL': 'Não',
        'OK':'OK',
      },
      'LINK': 'Digite o link a seguir para visualizar o progresso atual da pesquisa:',
      'LINKENCUESTA': 'Gere o link para visualizar o progresso atual da pesquisa:',
      'ACTIONS':{
        'TITULO': 'Ações',
        'TITULO_ACTUALIZADO': 'Lembretes',
        'TITULO_ACCESS': 'Acesso à pesquisa',
        'WANNADO': 'O que você quer fazer?',
        'TITULO_VIRSMS': 'Portal de SMS virtual',
        'TITULO_MYCODE': 'Portal GetMyCode.culturalgo.com',
        'TITULO_BTNMYCODE': 'Vá para o portal GetMyCode',
      },
      'COMPLETO':{
        'TAG': 'A pesquisa foi concluída com sucesso',
        'CARDTIT': 'Consulta de resultados',
        'LINK': 'Digite o seguinte link para visualizar os resultados obtidos na pesquisa:'
      },
      'PORTAL':{
        'LABEL01':'Portal de contagem',
        'LABEL02':'Gerar chave de acesso'
      },
      'PULSE':{
        /// Survey advancement
        'LABELPRO':'Progresso da pesquisa',
        'LINKEN': 'Link da pesquisa ',
        'LINKRES': 'Link de resultado ',
        'ENCUESTANOENVIADA': 'Nenhuma pesquisa de verificação de pulso foi lançada ainda',
      },
      'CIERRE':{
        'BCONTEOS':'Portal de contagem',
        'BACCESO':'Gerar chave de acesso',
        'LINKPORTAL': 'Copiar link de acesso ao portal de contagem',
        'COPYLINK':'Copiado para sua prancheta',
        'REMANDER':'Lembretes',
        'REMANDERC2':'Lembretes para pessoas que não terminaram',
        'REMANDER1':'Lembretes para pessoas que ainda não participaram de sua pesquisa',
        'REMANDER2':'Lembretes para pessoas que começaram e ainda não terminaram',
        'GETURLSURV_1': 'Gerar link do provedor de acesso à pesquisa',
        'GETURLSURV_2': 'O link para o provedor de acesso à pesquisa foi gerado, agora você pode copiá-lo clicando no mesmo botão',
        'GETURLSURV_3': 'Copiar link do provedor de acesso à pesquisa',
        'ASIGUSERDEMO':'Atribuição de uma palavra-passe',
      },
      'MOD_TEX_SEND_RECO':'Envio de e-mail...',

    },
  }
};
